// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer .socialmedialist{padding-top:15px}@media (min-width:768px){.footer .socialmedialist{padding-top:0}}.footer .socialmedialist__items{display:flex;flex-wrap:wrap;margin:-.83333rem}@media (min-width:768px){.footer .socialmedialist__items{justify-content:space-between}}.socialmedialist__item{padding:.83333rem}.socialmedialist__icon{font-size:2rem}.footer .socialmedialist__link:hover{--tw-text-opacity:1;color:rgba(54,215,183,var(--tw-text-opacity))}", ""]);
// Exports
module.exports = exports;
